
var cObject = (function () {
    function cObject() {
        return this;
    }
    return cObject;
})();
cObject.prototype = new Object();
cObject.prototype.clone = function () {
    function a() {
    }
    a.prototype = this;

    return new a();
};

export default cObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/cObject.js